import RestClient from '@/api/api';

class PricingCatalogAPI extends RestClient {
  async download() {
    const response = await this.makeRequest('get', '/pricing_catalog', null, {
      responseType: 'blob'
    });
    return response;
  }

  async upload(file) {
    const formData = new FormData();
    formData.append('file', file);

    return await this._post('/pricing_catalog', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  async reset() {
    return await this._delete('/pricing_catalog');
  }
}

export default new PricingCatalogAPI();
